import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getSubHeaderStyles = (theme: Theme) =>
    css({
        display: 'flex',
        alignItems: 'center',
        padding: `${theme.spacing(2)}px  ${theme.spacing(4)}px`,
        backgroundColor: theme.palette.white,
        justifyContent: 'space-between',
    });

export const getSubHeaderTitleStyles = () =>
    css({
        margin: 0,
    });
